export default __webpack_public_path__ + "static/media/minato.c2feb048.png";